module.exports = __webpack_public_path__ + "img/black_elegant_leather_jacket-120x156.9c7b84bb.jpg";